import Vue from 'vue'

import ElementUI from 'element-ui'
import './styles/element-ui.scss'
import 'element-ui/lib/theme-chalk/index.css'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // lang i18n
import elementZHLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import '@/styles/style.css'
import '@/styles/index.scss' // global css
import '@/styles/pcStyle.css' // global css
import '@/styles/pcFontCss/middleFont.css' // global css
import VueI18n from 'vue-i18n';

import VueSignaturePad from "vue-signature-pad"; //签名

import './permission' // permission control

//富文本编辑器
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import VueUeditorWrap from 'vue-ueditor-wrap'
// Vue.component('vue-ueditor-wrap', VueUeditorWrap)


import App from './App'
import store from './store'
import router from './router'
import $ from 'jquery'

import * as api from './utils/api'
import * as storage from './utils/storage';
// vant
// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

// mintUi
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(Mint);

// set ElementUI lang to EN
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(VueSignaturePad);
Vue.prototype.$JQ = $;
Vue.prototype.api = api;

Vue.config.productionTip = false;
Vue.prototype.$storage = storage;

Vue.use(VueI18n)
const i18n = new VueI18n({ // 双语
  locale: 'zh_cn',
  messages: {
      'zh_cn': {...require('./components/lang/zh_cn'),...elementZHLocale},
      'zh_tw': {...require('./components/lang/zh_tw'),...elementTWLocale},
      'en': {...require('./components/lang/en'),...elementEnLocale},
  },
  silentTranslationWarn: true
})


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  // VueQuillEditor,
  render: h => h(App)
})
